import axios from 'axios';

export const FETCH_NOTIFICATIONS_REQUEST = 'FETCH_NOTIFICATIONS_REQUEST';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_FAILURE = 'FETCH_NOTIFICATIONS_FAILURE';
export const MARK_NOTIFICATION_AS_READ = 'MARK_NOTIFICATION_AS_READ';
export const MARK_ALL_AS_READ = 'MARK_ALL_AS_READ';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

// Action to fetch notifications from API
export const fetchNotifications = () => async (dispatch) => {
  dispatch({ type: FETCH_NOTIFICATIONS_REQUEST });

  try {
    const response = await axios.get('notifications.json');
    dispatch({
      type: FETCH_NOTIFICATIONS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_NOTIFICATIONS_FAILURE,
      payload: error.message
    });
  }
};

// Action to mark a notification as read
export const markNotificationAsRead = (id) => ({
  type: MARK_NOTIFICATION_AS_READ,
  payload: id
});

// Action to mark all notifications as read
export const markAllAsRead = () => ({
  type: MARK_ALL_AS_READ
});

// Action to remove a notification
export const removeNotification = (id) => ({
  type: REMOVE_NOTIFICATION,
  payload: id
});
